import { createSlice } from "@reduxjs/toolkit";
import { reducerPaths } from "../../app/reducerPaths";
import { revertAll } from "../../app/revertAll";
import { carsInNegotiationApi } from "./carsInNegotiationApi";

const initialState = {
  carsInNegotiationData: {
    data: [],
  },
  biddersNegotiationListData: {
    data: []
  }
};

const carsInNegotiation = createSlice({
  name: reducerPaths.carsInNegotiation,
  initialState,
  reducers: {
    setCarsInNegotiationMultipleFields: (state, action) => {
      for (let i = 0; i < Object.entries(action?.payload)?.length; i++) {
        state[Object.entries(action?.payload)?.[i]?.[0]] = Object.entries(action?.payload)?.[i]?.[1];
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(revertAll, () => initialState);
    builder.addMatcher(
      carsInNegotiationApi.endpoints.getBiddersNegotiationList.matchFulfilled,
      (state, { payload }) => {
        console.log(payload, `getBiddersNegotiationList`)
        state.biddersNegotiationListData.data = payload?.TopBids?.map?.(currBidder => {
          return {
            ...(currBidder || {}),
            dealerId: currBidder?.Dealer_Id,
            deliveryMode: currBidder?.Delivery_Mode,
            bidDate: currBidder?.Bid_Date,
            amount: currBidder?.Bid_Amount,
            id: currBidder?.Bid_Id,
            Vehicle_Id: currBidder?.Vehicle_Id
          }
        })
      }
    );
    builder.addMatcher(
      carsInNegotiationApi.endpoints.getBiddersNegotiationListBuyNow.matchFulfilled,
      (state, { payload }) => {
        console.log(payload, `getBiddersNegotiationListBuyNow`)
        state.biddersNegotiationListData.data = [{
          ...(payload?.TopBids || {}),
          dealerId: payload?.TopBids?.Dealer_Id,
          deliveryMode: payload?.TopBids?.Delivery_Mode,
          bidDate: payload?.TopBids?.Bid_Date,
          amount: payload?.TopBids?.Bid_Amount,
          id: payload?.TopBids?.Bid_Id,
          Vehicle_Id: payload?.TopBids?.Vehicle_Id
        }] 
      }
    );
  } 
});

export const {
  setCarsInNegotiationMultipleFields
} = carsInNegotiation.actions;

export default carsInNegotiation.reducer;
